import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getRangosDocumentos = async () => {
    const respuesta = PrivateInterceptor('Finanzas/RangosDocumentos/getRangosDocumentos', 'GET')
    return respuesta
};

export const GuardarRango = (Datos) => {
    const respuesta = PrivateInterceptor("Finanzas/RangosDocumentos/GuardarRango", "POST", {Datos});
    return respuesta;
};

export const EditarRango = (Datos) => {
    const respuesta = PrivateInterceptor("Finanzas/RangosDocumentos/EditarRango", "POST", {Datos});
    return respuesta;
};

export const getUltimoRangoPorTipo = (IdTipoRango) => {
    const respuesta = PrivateInterceptor(`Finanzas/RangosDocumentos/getUltimoRangoPorTipo/${IdTipoRango}`, 'GET');
    return respuesta;
};

export const chageEstadoRangos = async (data) => {
  const result = await PrivateInterceptor(`Finanzas/RangosDocumentos/chageEstadoRangos`, 'POST', data);
  return result;
}

export const getRangosDocumentosPorID = async (IdTipoRango) => {
    const respuesta = PrivateInterceptor('Finanzas/RangosDocumentos/getRangosDocumentosPorID', 'POST', {IdTipoRango})
    return respuesta
};
